import { useEffect } from "react";
import { PRODUCT_PAGE_META } from "@/shared/products/productsMeta";
import { updateRouteSeo } from "@/shared/lib/pageSeo";

export function useProductSeo(key: "home" | "crisis") {
  const seo = PRODUCT_PAGE_META[key];
  useEffect(() => { updateRouteSeo(seo.path, seo.title); }, [seo]);
}
